<template>
  <div>
    <div class="row">
      <div class="col-12">
        <card title="Update user details">
          <form @submit.prevent="updateUser">
            <label>Name</label>
            <div class="form-group">
              <input 
                type="text"
                class="form-control form-control-lg"
                placeholder=""
                v-model="user.name"
              />
            </div>            

            <label>Email</label>
            <div class="form-group">
              <input 
                type="email"
                class="form-control form-control-lg"
                placeholder=""
                v-model="user.email"
              />
            </div>

            <label>Phone</label>
            <div class="form-group">
              <input 
                type="text"
                class="form-control form-control-lg"
                placeholder=""
                v-model="user.phone"
              />
            </div>                    

            <template v-if="isAdmin || currentUser.id === user.id">
              <label>Password</label>
              <div class="form-group">
                <input 
                  :type="isPasswordShowing ? 'text' : 'password'"
                  class="form-control form-control-lg"
                  placeholder="password"
                  v-model="user.password"
                />
                <div class="show-password" @click="toggleShowPassword($event)">
                  <fa :icon="['fas', `${isPasswordShowing ? 'eye' : 'eye-slash'}`]"/>
                </div>
              </div>
            </template>

            <label v-if="isAdmin">Grant Access</label>
            <div v-if="isAdmin" class="form-group">
              <ul class="user-access-list">
                <li v-for="access in accessList" :key="access">
                  <label :for="access">
                    <input type="checkbox" :id="access" v-model="user.access" :value="access"> {{ access }}
                  </label>
                </li>
              </ul>
            </div>

            <div class="form-group">
              <input 
                type="submit"
                class="btn btn-primary"
                value="Update"
              />
            </div>
          </form>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import { USER_EDIT, FETCH_USER_BY_ID } from '@/store/actions.type'

export default {

  data() {
    return {
      isPasswordShowing: false,
      user: {},
      accessList: [
        'assets',
        'deleted-assets',
        'pages',
        'navigation',
        'live',
        'live-toggle',
        'settings',
        'users',
        'email-properties',
        'heatmaps'
      ]
    }
  },

  computed: {
    currentUser () {
      return this.$store.getters.currentUser
    },

    isAdmin () {
      return this.$store.getters.currentUser.isAdmin
    }
  },

  beforeMount() {
    const userId = this.$route.params.userId
    this.$store.dispatch(FETCH_USER_BY_ID, userId).then(res => {
      this.user = res.user
    })
  },

  methods: {
    updateUser () {
      this.$store.dispatch(USER_EDIT, this.user).then(() => {
        this.$notify({
          message: 'User updated',
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "success"
        })

        window.location.reload()
      }).catch(() => {
        this.$notify({
          message: 'An error occured',
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "danger"
        })
      })
    },

    toggleShowPassword () {
      this.isPasswordShowing = !this.isPasswordShowing
    }
  }
}
</script>
<style lang="scss" scoped>
.form-group {
  position: relative;
}

.show-password {
  cursor: pointer;
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
}

.user-access-list {
  list-style: none;
  padding: 0 16px;

  li {
    label {
      font-size: 14px;
      user-select: none;
    }
  }
}
</style>
